import React, { useContext, useEffect, useState, useRef } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import NetworkBarLink from './_partials/NetworkBarLink';
import HomeIcon from '../Icons/Home';
import Eyecon from '../Icons/FollowingWatch';
import PopularIcon from '../Icons/Popular';
import DailyDeviationIcon from '../Icons/DailyDeviation';
import TopicsIcon from '../Icons/Topics';
import NewestIcon from '../Icons/Newest';
import RecommendedIcon from '../Icons/Recommended';
import { SessionContext } from '../Context/SessionContext';
import { MobileContext } from '../Context/MobileContext';
import GroupList from './_partials/GroupList';
import { watchedGroupsStreamId, recommendedGroupsStreamId, NETWORKBAR_FEEDBACK_URL, } from './redux/constants';
import { Nav } from '../a11y/headings/tagWrappers';
import { VisuallyHidden } from '../a11y';
import Heading from '../a11y/headings/Heading';
import Label from './_partials/Label';
import EmptyWatchedGroups from './_partials/EmptyWatchedGroups';
import { BiEventType, BiLoggerContextProvider } from '../biLogger';
import NetworkBarFTUETooltip from './NetworkBarFTUETooltip';
import { ThemeOverride } from '../Context/ThemeContext';
import { ThemeOptions } from '../publicSession';
import Message2 from '../Icons/Message2';
import s from './NetworkBar.scss';
var menuItemIconMap = {
    home: HomeIcon,
    deviantsYouWatch: Eyecon,
    dailyDeviations: DailyDeviationIcon,
    topics: TopicsIcon,
    popular: PopularIcon,
    new: NewestIcon,
};
var NetworkBar = function (_a) {
    var initialFetch = _a.initialFetch, _b = _a.isVisible, isVisible = _b === void 0 ? true : _b, isCollapsed = _a.isCollapsed, selectedItem = _a.selectedItem, showWatchedGroupsEmptyState = _a.showWatchedGroupsEmptyState, className = _a.className, isInitialized = _a.isInitialized, mainNavItems = _a.mainNavItems, showFTUE = _a.showFTUE, canSeeOldWatch = _a.canSeeOldWatch;
    var _c = useState(true), hideContent = _c[0], setHideContent = _c[1];
    var scrollableRef = useRef(null);
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var isLoggedIn = useContext(SessionContext).isLoggedIn;
    var tabIndex = isVisible ? 0 : -1;
    useEffect(function () {
        if (!isInitialized) {
            initialFetch();
        }
        if (isInitialized) {
            setHideContent(false);
            var scrollable = scrollableRef.current;
            var selectedNode = scrollable === null || scrollable === void 0 ? void 0 : scrollable.querySelector("." + s['selected-item']);
            if (!selectedNode || !scrollable) {
                return;
            }
            var _a = selectedNode.getBoundingClientRect(), selectedTop = _a.top, selectedHeight = _a.height;
            var scrollableHeight = scrollable.getBoundingClientRect().height;
            // position to center
            scrollable.scrollTop =
                scrollable.scrollTop +
                    selectedTop -
                    (scrollableHeight - selectedHeight) / 2;
        }
    }, [initialFetch, isInitialized]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classnames(!isMobile && s['scroll-wrapper'], isCollapsed && s['collapsed'], hideContent && s['hidden'], className), ref: scrollableRef },
            React.createElement(Nav, { className: s['root'] },
                React.createElement(VisuallyHidden, null,
                    React.createElement(Heading, null, t('common.networkBar'))),
                React.createElement("ul", null, mainNavItems.map(function (item) {
                    var _a, _b;
                    return item &&
                        (!item.restrictLoggedIn || isLoggedIn) && (React.createElement("li", { key: item.key },
                        React.createElement(NetworkBarLink, { label: item.key, url: item.url, icon: menuItemIconMap[item.key], tabIndex: tabIndex, isCollapsed: !isMobile && isCollapsed, isSelected: selectedItem === ((_a = item.pageType) !== null && _a !== void 0 ? _a : item.key), className: classnames(selectedItem === ((_b = item.pageType) !== null && _b !== void 0 ? _b : item.key) &&
                                s['selected-item']), hasNewContent: item.hasNewContent, menuItems: isMobile &&
                                item.key === 'deviantsYouWatch' &&
                                canSeeOldWatch
                                ? [
                                    {
                                        label: t('networkBar.navItems.deviantsYouWatch.actions.oldWatch'),
                                        link: Url.watchLink(),
                                        biData: {
                                            evid: BiEventType.NETWORK_BAR_3DOTS_SELECT,
                                            sectionname: item.key,
                                            indicator: item.hasNewContent ? 1 : 0,
                                            menu_item: 'oldWatch',
                                        },
                                    },
                                ]
                                : undefined })));
                })),
                React.createElement("div", { className: s['group'] },
                    React.createElement(BiLoggerContextProvider, { value: { sectionname: 'groups' } },
                        showWatchedGroupsEmptyState && !isCollapsed && (React.createElement(React.Fragment, null,
                            React.createElement(Label, { className: s['label'], isCollapsed: isCollapsed }, t('networkBar.subheader.groups')),
                            React.createElement(EmptyWatchedGroups, null))),
                        !showWatchedGroupsEmptyState && (React.createElement(GroupList, { streamId: watchedGroupsStreamId, tabIndex: tabIndex, selectedItem: selectedItem, isCollapsed: isCollapsed, selectedItemClassName: s['selected-item'] },
                            React.createElement(Label, { className: s['label'], isCollapsed: isCollapsed }, t('networkBar.subheader.groups'))))),
                    React.createElement(BiLoggerContextProvider, { value: { sectionname: 'recommended groups' } },
                        React.createElement(GroupList, { streamId: recommendedGroupsStreamId, tabIndex: tabIndex, selectedItem: selectedItem, isCollapsed: isCollapsed, selectedItemClassName: s['selected-item'] },
                            React.createElement(RecommendedIcon, { disableDefaultColors: true, customSizable: true, className: s['recommended-separator'] }),
                            React.createElement(Label, { className: s['label'], isCollapsed: isCollapsed }, t('networkBar.subheader.recommendedGroups'))))),
                React.createElement("div", { className: s['group'] },
                    React.createElement(NetworkBarLink, { label: "feedback", url: NETWORKBAR_FEEDBACK_URL, icon: Message2, tabIndex: tabIndex, isCollapsed: !isMobile && isCollapsed })))),
        showFTUE && !isMobile && (React.createElement(ThemeOverride, { theme: ThemeOptions.DARK },
            React.createElement(NetworkBarFTUETooltip, { placement: "right", className: s['ftue'] })))));
};
NetworkBar.displayName = 'NetworkBar';
export default NetworkBar;
//# sourceMappingURL=NetworkBar.js.map